export class LoginFlyout {
    constructor() {
        $('#msQMyAccountNavWrapper > ul').on('click',function(){
            $('#msQMyAccountNavWrapper').addClass('menuHover');
            $('#msQMyAccountNavWrapper ul ul > li').css('display','list-item');
        });
        $('#msQMyAccountNavWrapper > ul').on('mouseenter',function(){
            $('#msQMyAccountNavWrapper').addClass('menuHover');
            $('#msQMyAccountNavWrapper ul ul > li').css('display','list-item');
        });
        $('#msQMyAccountNavHeadingWrapper .msQMyAccountNavCloseIcon').on('click',function(){
            $('#msQMyAccountNavWrapper').removeClass('menuHover');
            $('#msQMyAccountNavWrapper ul ul > li').css('display','none');
            return false;
        });

        var hoverTimer;
        $('#msQMyAccountNavWrapper').hover(
            function () {
                $(this).addClass('menuHover');
            }, function () {
                clearTimeout(hoverTimer);
                hoverTimer = setTimeout(function() {
                    if(!$('#msQMyAccountNavWrapper').is(':hover')) {
                        $('#msQMyAccountNavWrapper').removeClass('menuHover');
                    }
                }, 2000);
            }
        );

        if ($(".enableFeloginBox").length > 0) {
            var id = "#msQMyAccountNavWrapper";
            $(id).dequeue();
            $(id).addClass("menuHover").delay(10000).queue(function () {
                $(id).removeClass("menuHover");
            });
        }
    }
}